import Vue from 'vue';

/**
 * 让tooltip快速消失
 */
Vue.directive('tooltipMove', {
  inserted: (el, binding) => {
    el.addEventListener('mouseout', () => {
      let toolTipAll = document.getElementsByClassName('vh-tooltip__popper');
      if (toolTipAll && toolTipAll.length > 0) {
        for (const item of toolTipAll) {
          item.style.display = 'none';
        }
      }
    });
  }
});
